export default "__VITE_ASSET__Dmv0St2l__"